import React from 'react'
import { useNavigate } from 'react-router-dom';
import { IconButton } from 'rsuite';
import { Icon } from '@rsuite/icons';
import '../../App.css';
import * as faHome from '@fortawesome/free-solid-svg-icons/faHome';

const FaSvgIcon = ({ faIcon, ...rest }) => {
    const { width, height, svgPathData } = faIcon;
    return (
      <svg {...rest} viewBox={`0 0 ${width} ${height}`} width="1.5em" height="1.5em" fill="#009ec1">
        <path d={svgPathData}></path>
      </svg>
    );
  };

const HomeButton = ({ items, onPress }) => {
    const navigate = useNavigate();

    return <div className="App-home-button">
      <IconButton appearance="subtle" icon={<Icon as={FaSvgIcon} faIcon={faHome} />} circle onClick={() => navigate('/')}/>
    </div>
}

export default HomeButton